






import { Prefix } from "@/types/debug-mode";
import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class PrefixRemove extends Vue {
  @Prop({ required: true })
  prefix!: Prefix;

  remove(prefix: Prefix) {
    if (window.confirm("Clicking OK will stop watching this prefix. Are you sure you want to do this?")) {
      this.$ga.button("Unwatch prefix");
      this.$store.dispatch("debugMode/removePrefix", prefix);

      this.$router.push({ name: "prefixes" });
    }
  }
}
